import type { ReactNode } from 'react';

import BpkBottomSheet from '@skyscanner/backpack-web/bpk-component-bottom-sheet';
import { PADDING_TYPE } from '@skyscanner/backpack-web/bpk-component-bottom-sheet/src/BpkBottomSheet';
import {
  BpkButtonV2,
  SIZE_TYPES,
} from '@skyscanner/backpack-web/bpk-component-button';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import { withI18n } from '../../contexts/i18n/index';

import type { I18nService } from '@shared/types/i18n';

import STYLES from './AtypicalDealsBottomSheet.module.scss';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  mainContent?: ReactNode;
  i18n: I18nService;
  explanation: string;
};
const cls = cssModules(STYLES);

const AtypicalDealsBottomSheet = ({
  explanation,
  i18n: { translate },
  isOpen,
  mainContent,
  onClose,
}: Props) => (
  <BpkBottomSheet
    id="atypical-deals--modal"
    ariaLabel={translate('hd_price_range_tip')}
    isOpen={isOpen}
    onClose={onClose}
    paddingStyles={{
      top: PADDING_TYPE.none,
      start: PADDING_TYPE.lg,
      end: PADDING_TYPE.lg,
      bottom: PADDING_TYPE.lg,
    }}
    closeOnEscPressed
    closeOnScrimClick
  >
    <div>
      {mainContent}
      <div className={cls('AtypicalDealsBottomSheet__explanation')}>
        <BpkText textStyle={TEXT_STYLES.footnote}>{explanation}</BpkText>
      </div>
      <BpkButtonV2
        onClick={onClose}
        className={cls('AtypicalDealsBottomSheet__footerBtn')}
        size={SIZE_TYPES.large}
      >
        <BpkText textStyle={TEXT_STYLES.label1}>
          {translate('Reviews_GotIt')}
        </BpkText>
      </BpkButtonV2>
    </div>
  </BpkBottomSheet>
);

export default withI18n(AtypicalDealsBottomSheet);
